import { Page } from 'codegen/schema'
import { Layout } from 'components/layout'
import { RichTextContent } from 'components/rich-text-content'
import { useLoadSettings } from 'hooks/database/use-load-settings'
import { pageQuery } from 'lib/queries'
import { getClient } from 'lib/sanity.server'
import { GetStaticProps } from 'next'
import { groq } from 'next-sanity'

import { urlWithSiteOrigin } from '../../utils/url-with-site-origin'

export interface FeaturesPageProps {
  data: { page: Page; query: string; queryParams: string }
}

export const Features = ({ data: { page } }: FeaturesPageProps) => {
  useLoadSettings()
  const { title, metaDescription, heroImage, body } = page

  return (
    <Layout
      seoProps={{
        title,
        description: metaDescription,
        canonicalUrl: urlWithSiteOrigin('/features/'),
        pageUrl: urlWithSiteOrigin('/features/'),
      }}
    >
      <RichTextContent heroImage={heroImage} body={body} />
    </Layout>
  )
}

/**
 * Fetch the data from Sanity based on the slug
 */
export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const query = groq`${pageQuery}`
  const queryParams = { slug: 'features' }
  const pageData = await getClient(preview).fetch(pageQuery, queryParams)
  const page = pageData?.[0]

  // Escape hatch, if our query failed to return page
  if (!page) return { notFound: true }

  return {
    props: {
      // Pass down the "preview mode" boolean to the client-side
      preview,
      // Pass down the initial content, and our query
      data: { page, query, queryParams },
    },
  }
}
